import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { FiVideo, FiEye, FiHeart, FiMessageSquare, FiTrendingUp, FiTrendingDown, FiThumbsDown } from 'react-icons/fi';
import { toast } from 'react-toastify';
import './Dashboard.css';

const Dashboard = () => {
  const [stats, setStats] = useState(null);
  const [popularWebinars, setPopularWebinars] = useState([]);
  const [unpopularWebinars, setUnpopularWebinars] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchDashboardData();
  }, []);

  const fetchDashboardData = async () => {
    try {
      const [statsRes, popularRes, unpopularRes] = await Promise.all([
        axios.get('/api/analytics/dashboard/'),
        axios.get('/api/analytics/popular/'),
        axios.get('/api/analytics/unpopular/'),
      ]);

      setStats(statsRes.data);
      setPopularWebinars(popularRes.data);
      setUnpopularWebinars(unpopularRes.data);
    } catch (error) {
      toast.error('Ошибка загрузки данных');
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return <div className="loading"><div className="spinner"></div></div>;
  }

  return (
    <div className="dashboard">
      <div className="stats-grid">
        <div className="stat-card">
          <div className="stat-icon" style={{ background: 'rgba(255, 102, 0, 0.1)' }}>
            <FiVideo style={{ color: 'var(--primary-color)' }} />
          </div>
          <div className="stat-content">
            <h3>{stats?.total_webinars || 0}</h3>
            <p>Всего вебинаров</p>
          </div>
        </div>

        <div className="stat-card">
          <div className="stat-icon" style={{ background: 'rgba(76, 175, 80, 0.1)' }}>
            <FiEye style={{ color: '#4caf50' }} />
          </div>
          <div className="stat-content">
            <h3>{stats?.total_views || 0}</h3>
            <p>Просмотров</p>
          </div>
        </div>

        <div className="stat-card">
          <div className="stat-icon" style={{ background: 'rgba(244, 67, 54, 0.1)' }}>
            <FiHeart style={{ color: '#f44336' }} />
          </div>
          <div className="stat-content">
            <h3>{stats?.total_likes || 0}</h3>
            <p>Лайков</p>
          </div>
        </div>

        <div className="stat-card">
          <div className="stat-icon" style={{ background: 'rgba(220, 53, 69, 0.1)' }}>
            <FiThumbsDown style={{ color: '#dc3545' }} />
          </div>
          <div className="stat-content">
            <h3>{stats?.total_dislikes || 0}</h3>
            <p>Дизлайков</p>
          </div>
        </div>

        <div className="stat-card">
          <div className="stat-icon" style={{ background: 'rgba(33, 150, 243, 0.1)' }}>
            <FiMessageSquare style={{ color: '#2196f3' }} />
          </div>
          <div className="stat-content">
            <h3>{stats?.total_comments || 0}</h3>
            <p>Комментариев</p>
          </div>
        </div>
      </div>

      <div className="dashboard-grid">
        <div className="dashboard-card">
          <div className="card-header">
            <h2 className="card-title">
              <FiTrendingUp /> Популярные вебинары
            </h2>
          </div>
          <div className="webinar-list">
            {popularWebinars.length > 0 ? (
              popularWebinars.map((webinar) => (
                <Link
                  key={webinar.id}
                  to={`/webinars/${webinar.id}`}
                  className="webinar-item"
                >
                  <div className="webinar-info">
                    <h4>{webinar.title}</h4>
                    <p className="webinar-meta">
                      {webinar.speaker_data?.full_name} • {new Date(webinar.recording_date).toLocaleDateString('ru-RU')}
                    </p>
                  </div>
                  <div className="webinar-stats">
                    <span><FiEye /> {webinar.views_count}</span>
                    <span><FiHeart /> {webinar.likes_count}</span>
                    <span><FiThumbsDown /> {webinar.dislikes_count || 0}</span>
                  </div>
                </Link>
              ))
            ) : (
              <div className="empty-state">
                <p>Нет данных</p>
              </div>
            )}
          </div>
        </div>

        <div className="dashboard-card">
          <div className="card-header">
            <h2 className="card-title">
              <FiTrendingDown /> Наименее популярные
            </h2>
          </div>
          <div className="webinar-list">
            {unpopularWebinars.length > 0 ? (
              unpopularWebinars.map((webinar) => (
                <Link
                  key={webinar.id}
                  to={`/webinars/${webinar.id}`}
                  className="webinar-item"
                >
                  <div className="webinar-info">
                    <h4>{webinar.title}</h4>
                    <p className="webinar-meta">
                      {webinar.speaker_data?.full_name} • {new Date(webinar.recording_date).toLocaleDateString('ru-RU')}
                    </p>
                  </div>
                  <div className="webinar-stats">
                    <span><FiEye /> {webinar.views_count}</span>
                    <span><FiHeart /> {webinar.likes_count}</span>
                    <span><FiThumbsDown /> {webinar.dislikes_count || 0}</span>
                  </div>
                </Link>
              ))
            ) : (
              <div className="empty-state">
                <p>Нет данных</p>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
